<template>
  <video-quick-tour
    :height="videoHeight"
    video-name="explainer_IdeaPlan"
  >
    <h4 class="my-3 my-xl-0 font-outfit-medium">
      {{ $t('welcomeToIdeaPlan') }}
    </h4>
    <div v-html="$t('ideaPlanQuickTourText')" />
  </video-quick-tour>
</template>

<script>
import VideoQuickTour from '@/components/_v2/VideoQuickTour'

export default {
  name: 'IdeaPlanQuickTour',

  components: {
    VideoQuickTour
  },

  props: {
    videoHeight: {
      type: String,
      default: '320'
    }
  }
}
</script>
